export default "__VITE_ASSET__CI$8wxM7__"